import { getBaseRequest, setInternalServerError } from '../shared/scripts';
import RequestCommon from './common/Request';


const rootUri = 'user';

class UserApi {
    static checkSession() {
        return RequestCommon.get(rootUri + '/check-session');
    }

    static keepAliveSession() {
        return RequestCommon.get(rootUri + '/keep-alive-session');
    }

    static login(){
        var path = "";
        switch(window.location.pathname){
            case '/session-expired':
            case '/internal-server-error':
                path = "/";
                break;
            default:
                path = window.location.pathname;
        }

        const redirectUri = path.replace(/\//g, 'xr-');
        const url = new URL(rootUri + '/authorize', window.location);
        url.searchParams.append('redirectUri', redirectUri);

        window.location.href = url;     
    }

    static async logout() {
        const request = new Request(rootUri + '/logout', {
            method: 'GET',
            redirect: 'manual',
            mode: 'no-cors'
        });
        try {
            const response = await fetch(request);
            if (response.type === "opaqueredirect") {
                window.location.href = response.url;
            }
        } catch (error) {
            setInternalServerError(error);
        }
    }

    static async logoutSessionExpired() {
        try {
            await fetch(getBaseRequest(rootUri + '/logout-session-expired'));
            //todo kh check if this is needed, ...redirected from the server
            window.location.href = '/clientapp/session-expired';
        } catch (error) {
            setInternalServerError(error);
        }
    }
}

export default UserApi;